import { render, staticRenderFns } from "./ZpIcon.vue?vue&type=template&id=0a86c1df"
import script from "./ZpIcon.vue?vue&type=script&lang=js"
export * from "./ZpIcon.vue?vue&type=script&lang=js"
import style0 from "./ZpIcon.vue?vue&type=style&index=0&id=0a86c1df&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports